import { useContext, useEffect, useState } from "react";

export const useNotFinishedtModal = (messages, onOk) => {

    const [dialogVisible, setDialogVisible] = useState(false)

    const cancelHandler = e => {
        setDialogVisible(false)       
    }

    const acceptHandler = e => {
        onOk()
        setDialogVisible(false)
    }

    const showDialog = () => {        
        setDialogVisible(true)
    } 

    return {dialogVisible, showDialog, cancelHandler, messages, acceptHandler}

}